export default __webpack_public_path__ + "static/media/reimprimir.b3e7e2d8.svg";